import React, { useMemo, useEffect } from 'react';

import PropTypes from 'prop-types';

import { SimpleTable } from '~/components';
import { t, canURL } from '~/helpers';

import MyForm from './form';

export default function Cota({ active, toggleConfirmButton }) {
  const cota = [
    { label: 'S', value: t('s.geral.opcoes.sim') },
    { label: 'N', value: t('s.geral.opcoes.nao') },
  ];

  // permissions user URL
  const permissions = useMemo(() => canURL(), []);

  useEffect(() => {
    toggleConfirmButton(false);
  }, []);

  return (
    <SimpleTable
      url="empresasveiculoscotas"
      cells={[
        {
          id: 'nomeproduto',
          label: t('s.cadastro.empresaveiculo.nomeproduto'),
        },
        {
          id: 'controlacotaempresaveiculocota',
          label: t('s.cadastro.empresaveiculo.controlacotaempresaveiculocota'),
          converter: cota,
        },
        {
          id: 'volumeempresaveiculocota',
          label: t('s.cadastro.empresaveiculo.volumeempresaveiculocota'),
        },
        {
          id: 'saldoempresaveiculocota',
          label: t('s.cadastro.empresaveiculo.saldoempresaveiculocota'),
        },
      ]}
      unique={['idempresaveiculo', 'idproduto']}
      form={MyForm}
      onCreate={permissions.post_cota}
      onUpdate={permissions.put_cota}
      onDelete={permissions.delete_cota}
      title={t('s.cadastro.empresaveiculo.cota')}
      restProps={active}
      query={{
        wherefield: ['idempresaveiculo'],
        valuewherefield: [active.idempresaveiculo],
        typewherefield: ['EQUALS'],
      }}
    />
  );
}

Cota.propTypes = {
  active: PropTypes.objectOf(PropTypes.any).isRequired,
  toggleConfirmButton: PropTypes.func.isRequired,
};
